import { useTranslation } from 'react-i18next';

import OriginLocation from 'classes/StandingData/OriginLocation/OriginLocation';

interface IProps {
	origin: OriginLocation;
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	selectedLanguage: string;
}

const OriginLocationLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-2">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:DESCRIPTION')}</label>
							<div>
								<input
									className="form-control"
									error-key={'NameTranslations'}
									name="nameTranslations"
									onChange={props.handleValueChange}
									type="text"
									value={
										props.origin.nameTranslations[props.selectedLanguage] || ''
									}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default OriginLocationLanguageInput;
